import { GetAllAsync, GetAsync, PutAsync } from './api';
import { UserSpecialRoleResponse } from '../types/responses/user-special-role-response';

const UserSpecialRoleEndpoint = `users/special-roles`;

/**
 * Gets the Special Roles list.
 * @returns the list of Special Roles.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods/GET
 */
export const GetUserSpecialRolesAsync = async () =>
  GetAsync<UserSpecialRoleResponse[]>(`${UserSpecialRoleEndpoint}`);

/**
 * Gets the User Special Roles by id.
 * @param organisationId - the ID of the Users' organisation to retrieve
 * @param userId - the ID of the User to retrieve
 * @returns the list of Special Role Id.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods/GET
 */
export const AdminGetUserSpecialRolesAsync = async (
  organisationId: number,
  userId: number
) =>
  GetAllAsync<number>(
    `organisations/${organisationId}/users/${userId}/special-roles`
  );

/**
 * Updates the User Special Roles by completely replacing it.
 * @param organisationId - the ID of the Users' organisation to retrieve
 * @param userId - the ID of the entity to update [PUT]
 * @param departments - the User Special Roles to update [PUT]
 * @returns the updated User Special Roles object.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods/PUT
 */
export const AdminPutUserSpecialRolesAsync = async (
  organisationId: number,
  userId: number,
  departments: number[]
) =>
  PutAsync<number[]>(
    `organisations/${organisationId}/users/${userId}/special-roles`,
    departments
  );
